(function($)
{

    $.fn.msxibuttonselect = function(options)
    {
        // build main options before element iteration
        var opts = $.extend({}, $.fn.msxibuttonselect.defaults, options);

        return this.each(function() {
            var $this = $(this);
            // build element specific options
            var eOpts = $.metadata ? $.extend({}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend({}, eOpts, $this.dataset()) : eOpts;

            var $hiddenInput = eOpts['hiddenInput'] ? $(eOpts['hiddenInput']) : $this.children('input:hidden');
            var $options = $this.find('.options');

            $options.find('.option').hover(function() {
                $(this).addClass('ui-state-hover');
            }, function() {
                $(this).removeClass('ui-state-hover');
            });
            $options.find('.option').click(function() {
                var $selected = $(this);
                $selected.addClass('selected ui-state-active').siblings().removeClass('selected ui-state-active');
                $hiddenInput.val($selected.find('input:hidden').val()).change();
            });
        });
    };
    //
    // plugin defaults
    //
    $.fn.msxibuttonselect.defaults = {
        hiddenInput: '' // Selector for custom hidden input field(s)
    };

})(jQuery);